import React from 'react'
import { scroller } from 'react-scroll';
import {useNavigate , useLocation} from 'react-router-dom'
export default function NavItem({to,label}) {
  const navigate = useNavigate();
  const location = useLocation();
  const handleNav=(id)=>{
    if(location.pathname !=="/"){
      navigate('/')
     
    }
    setTimeout(()=>{
      scroller.scrollTo(to, {
        offset:0,
        duration:500,
        delay: 0,
        smooth: 'easeInOutQuart'
      },1000);
    })
  
  }
  return (
<span
  onClick={()=>handleNav(to)}
  className=' text-white text-sm font-normal py-2 md:py-0 cursor-pointer'
>
  {label}
</span>
  )
}
